<template>
  <div class="emd-card-grid__column">
    <p class="emd-text _color_subtle _type_caption eu-mb_1">
      {{ title }}
    </p>

    <p class="emd-card-grid__line">{{ tId || '-' }}</p>
  </div>
</template>

<script>
export default {
  name: 'ChargesPaymentMethodTId',

  props: {
    title: { required: true },
    tId: { required: true }
  }
}
</script>
